import {AnimatePresence, motion} from "framer-motion";
import { NavLink } from "react-router-dom";
import { useState } from "react";
import SidebarMenu from "./SidebarMenu";
import {Link} from 'react-router-dom';

const routes = [
 
  {
    path:"/Dashboard",
    name:"DashBoard",
    icon:<img src={require('../asset/icons/adm_dashboard.png')} alt="" />,
  },
  {
    path:"/Administration",
    name:"Administration",
    icon: <img src={require('../asset/icons/adm_users.png')} alt="" />,
    subRoutes:[
      {
        //path:"/Setting/Examination/",
        path:"/Users",
        name:"Users",
        icon: <img src={require('../asset/icons/adm_users.png')} alt="" />,
      },  
      {
        //path:"/Setting/Examination/",
        path:"/Role Management",
        name:"Rolemgmnt",
        icon: <img src={require('../asset/icons/adm_users.png')} alt="" />,
      },
    ],
  },
  {
    path:"/ToolCategory",
    name:"Tools Category",
    icon: <img src={require('../asset/icons/adm_dept.png')} alt="" />,
  },
  {
    path:"/ToolMaster",
    name:"Tools Master",
    icon: <img src={require('../asset/icons/adm_tools.png')} alt="" />,
  },
  {
    path:"/StoreMaster",
    name:"Store Master",
    icon: <img src={require('../asset/icons/adm_stores.png')} alt="" />,
  },
  
  {
    path:"/Inventory",
    name:"Inventory",
    icon: <img src={require('../asset/icons/adm_inventory.png')} alt="" />,
  },
  {
    path:"/Indent",
    name:"Indents",
    icon: <img src={require('../asset/icons/adm_indent.png')} alt="" />,
  },
  {
    path:"/Transaction",
    name:"Tool Transaction",
    icon: <img src={require('../asset/icons/adm_issue.png')} alt="" />,
  },
/*
  {
    path:"/Dashboard",
    name:"Site Transaction",
    icon: <img src={require('../asset/icons/adm_exam_list.png')} alt="" />,
    subRoutes:[
      {
        //path:"/Setting/Examination/",
        path:"/SiteIssue",
        name:"Issue",
        icon: <img src={require('../asset/icons/adm_transfer.png')} alt="" />,
      },  
      {
        //path:"/Setting/Examination/",
        path:"/Dashboard",
        name:"Return",
        icon: <img src={require('../asset/icons/adm_inventory.png')} alt="" />,
      },
    ],
  }
*/    
  {
    path:"/ToolHistory",
    name:"HT Movement",
    icon: <img src={require('../asset/icons/adm_transfer.png')} alt="" />,
  },
  {
    path:"/Reports",
    name:"Reports",
    icon: <img src={require('../asset/icons/adm_transfer.png')} alt="" />,
  },
 /* 

*/

];


const Sidebar = ({children}) => {

  const [isOpen, setIsOpen] = useState(true)

  const inputAnimation = {
    hidden:{
      width: 0,
      padding: 0,
      opacity: 0,
      transition:{
        duration: 0.2,
      }
    },
    show:{
      width: "140px",
      padding: "5px 15px",
      opacity: 1,
      transition:{
        duration: 0.2,
      }
    }
  }

  const showAnimation = {
    hidden:{
      width: 0,
      opacity: 0,
      transition:{
        duration: 0.5,
      }
    },
    show:{
      width: "auto",
      opacity: 1,
      transition:{
        duration: 0.5,
      }
    }
  }

    return (
    <div className="main-container">
      <motion.div animate={{width: isOpen ? "300px":"60px", 
      transition:{
        duration: 0.5,
        type: "spring",
        damping: 11,
        }
      }} className="sidebar">
        <div className="top_section">
          {isOpen && (
            <motion.h1
              initial = "visible"
              animate = "show"
              exit = "visible"
              variants={showAnimation}
              className="logo"
            >

            </motion.h1>
          )}

        </div>

        <div style={{'marginTop':'10px','marginBottom' :'40px', 'flex-direction' : 'row'}}  className="c12-l-12">
          <div style={{'marginLeft' : '40px', 'marginRight' : '10px',}}>
          <img src={require('../asset/logo/logo-toolease.png')} alt="LOGO" width="138px" height="auto" />
          </div>
          
        </div>

        <section className="routes">
          {routes.map((route, index) => {
            if (route.subRoutes){
              return (
                <SidebarMenu 
                  setIsOpen={setIsOpen}
                  showAnimation={showAnimation} 
                  isOpen={isOpen} 
                  route={route}
                  key={route.name}
                />
              )
            }
            
            return (
              <NavLink 
              to={route.path}
              key={index}
              className="link"
              activeClassName="active" 
            >
              <div className="icon">{route.icon}</div>
              <AnimatePresence>
                {isOpen && (
                  <motion.div
                    initial = "hidden"
                    animate = "show"
                    exit = "hidden"
                    variants={showAnimation}
                    className="link_text">{route.name}</motion.div>
                )}
              </AnimatePresence>
            </NavLink>
            );
          })}
        </section>

        {/* <div className="footer">
          <Link to="/Modal" className="nav mb16" style={{'marginLeft':'10px', 'color': 'white', 'fontSize': '1rem'}}><u><i>Change Password</i></u></Link>
        </div> */}

        <AnimatePresence>
        {isOpen && (
          <motion.div
            initial = "hidden"
            animate = "show"
            exit = "hidden"
            variants={showAnimation}
            className="link_text"></motion.div>
        )}
      </AnimatePresence>

      </motion.div>
      <main>{children}</main>

      
    </div>
  )
}

export default Sidebar;
